import { render, staticRenderFns } from "./ApiKeyPage.vue?vue&type=template&id=72fdd17f&scoped=true"
import script from "./ApiKeyPage.vue?vue&type=script&lang=ts"
export * from "./ApiKeyPage.vue?vue&type=script&lang=ts"
import style0 from "./ApiKeyPage.vue?vue&type=style&index=0&id=72fdd17f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdd17f",
  null
  
)

export default component.exports